// Brand assets
export const LOGO_DARK =
    "https://customer-assets.emergentagent.com/job_custom-cake-webapp/artifacts/x66deyme_logo2.png";
export const LOGO_LIGHT =
    "https://customer-assets.emergentagent.com/job_custom-cake-webapp/artifacts/t8g0uzfg_logo-white-600x266.png";
